module.exports = angular.module('msi.paymetric.service', [
  require('@ordergroove/brandy/src/app/core/constants'),
  require('@ordergroove/brandy/src/app/utils')
]).name;

const inject = [
  '$window',
  '$document',
  '$q',
  'apiService',
  'apiUrls',
  '$compile',
  '$rootScope',
  '$timeout',
  'paymetricIframeTemplate'
];

function PaymetricServiceFactory(
  $window,
  $document,
  $q,
  apiService,
  apiUrls,
  $compile,
  $rootScope,
  $timeout,
  paymetricIframeTemplate
) {
  this.getSignedPaymetricPacket = function() {
    return apiService.paramAuth.get(
      '/msi/paymetric/get_signed_paymetric_packet',
      {
        noCamelCase: true,
        params: {
          redirect_url: `${apiUrls.masterDbUrl}/msi/paymetric/get_html_content?o=${$window.location.origin}`,
          merchant_ref: ''
        }
      }
    );
  };

  this.tokenize = function(payment) {
    let elem, timeout, $scope;
    return $q((resolve, reject) => {
      $scope = $rootScope.$new();

      $scope.resolve = resolve;
      $scope.payment = payment && payment.toApiJson ? payment.toApiJson() : {};

      if (payment && payment.ccNumber) {
        $scope.payment.cc_number = payment.ccNumber;
      }

      timeout = $timeout(() => reject(new Error('Paymetric Iframe timed out')), 30000);

      elem = $compile(paymetricIframeTemplate)($scope)[0];
      $document[0].querySelector('body').appendChild(elem);
    }).finally(() => {
      $timeout.cancel(timeout);
      $scope.$destroy();
      elem.remove();
    });
  };
}

PaymetricServiceFactory.$inject = inject;

angular.module(module.exports)
// for injection during tests
  .constant('paymetricIframeTemplate', '<og-paymetric og-payment="payment" og-on-finished="resolve(result)"></og-paymetric>')
  .service('paymetricService', PaymetricServiceFactory);
